import { colors } from '@resurs/midas'

export default {
  metabar: {
    fontSize: '1.2rem',
    background: colors.white,
  },
}
